import { styled } from '@mui/system'

const DrawerWrapper = styled('div')({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  flexDirection: 'column',
  height: '100%',
})

const LogoWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  padding: '16px',
  marginBottom: '8px',
})

const Logo = styled('p')({
  fontSize: '18px',
  fontWeight: 700,
  color: '#a855f7',
  letterSpacing: '2px',
  padding: '12px 20px',
  margin: 0,
  border: '2px solid rgba(168, 85, 247, 0.3)',
  borderRadius: '12px',
  textAlign: 'center',
  width: '80%',
  backdropFilter: 'blur(12px)',
  background: 'linear-gradient(135deg, rgba(147, 51, 234, 0.15) 0%, rgba(236, 72, 153, 0.15) 100%)',
  boxShadow: '0 4px 12px rgba(168, 85, 247, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.1)',
  transition: 'all 0.3s ease',
  cursor: 'pointer',
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'linear-gradient(135deg, #a855f7 0%, #ec4899 100%)',
    opacity: 0,
    transition: 'opacity 0.3s ease',
    zIndex: -1,
  },
  '&:hover': {
    transform: 'scale(1.05)',
    borderColor: '#a855f7',
    boxShadow: '0 8px 24px rgba(168, 85, 247, 0.4)',
    '&::before': {
      opacity: 0.1,
    },
  },
})

const DrawerStyle = { DrawerWrapper, Logo, LogoWrapper }

export default DrawerStyle